import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Language} from './model';

export interface LanguageState extends EntityState<Language> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Language' })
export class Store extends EntityStore<LanguageState> {

  constructor() {
    super();
  }

}
